module.exports = __webpack_public_path__ + "img/menu_banner.b430abeb.jpg";